import Vue from 'vue'

// 题库管理
const tikuManager = Vue.observable({
	// 当前激活的 id 对象，资源弹窗选中文件后，点击插入时，会根据当前激活 id 找到对应的文本框调用方法
	activeID: '',
	objIdData: {
		/**
		 * [id]: {
		 * 	 acceptFileType: '', 'image' | 'video' | 'audio' // 当前弹窗选择的类型（视频、图片、音频
		 * 	 deleteUpload: () => {},
		 * 	 urlData: [],
		 * 	 richTextContentMultiple: (file: File) => void, // 富文本更新函数
		 *   resourceDialogShow: false, // 弹窗开关
		 *   insertFileListOnChange: (fileArr: Array<File>) => void,
     *   uploadAcceptFileType: '', 本地上传选择文件的类型限制
     *   beforeUpload: async (file: File) => {}, 上传之前的校验，函数内 throw 出的话，终止上传
     *   inTimeClose: false // 表示需要关闭弹框
		 * }
		 */
	}
})

const fileDataManage = Vue.observable({
	/**
	 * 选中的文件资源或者文件夹
	 */
	checkedList: [],
	/**
	 * 文件列表
	 */
	fileArr: []
})

export { tikuManager, fileDataManage }

